import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { PaletteColor, PaletteColorOptions } from '@mui/material';

declare module '@mui/material/styles/createPalette' {
  // export interface PaletteOptions {
  //   grape: PaletteColorOptions;
  //   lime: PaletteColorOptions;
  //   cherise: PaletteColorOptions;
  // }

  interface Palette {
    grape: PaletteColor;
    lime: PaletteColor;
    cherise: PaletteColor;
  }

  export interface PaletteOptions {
    grape: PaletteColorOptions;
    lime: PaletteColorOptions;
    cherise: PaletteColorOptions;
  }
}

// const BASE_FONT_SIZE = 1.85; // rem

const theme = responsiveFontSizes(
  createTheme({
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: '1em',
          },
        },
      },
    },
    palette: {
      primary: {
        main: '#00b2d5',
      },
      secondary: {
        main: '#ed8b00',
      },
      grape: {
        main: '#952f45',
      },
      lime: {
        main: '#99c558',
      },
      cherise: {
        main: '#e4aab9',
      },
    },
    // typography: {
    //   fontFamily: [
    //     'Raleway',
    //     '-apple-system',
    //     'BlinkMacSystemFont',
    //     '"Segoe UI"',
    //     'Roboto',
    //     '"Helvetica Neue"',
    //     'Arial',
    //     'sans-serif',
    //     '"Apple Color Emoji"',
    //     '"Segoe UI Emoji"',
    //     '"Segoe UI Symbol"',
    //   ].join(','),
    //   body1: {
    //     fontSize: `${BASE_FONT_SIZE}rem`,
    //     lineHeight: 1.25,
    //   },
    //   body2: {
    //     fontSize: `${BASE_FONT_SIZE * 0.75}rem`,
    //     lineHeight: 1.25,
    //   },
    //   h1: {
    //     fontSize: `${BASE_FONT_SIZE * 2}rem`,
    //   },
    //   h2: {
    //     fontSize: `${BASE_FONT_SIZE * 1.5}rem`,
    //   },
    //   h3: {
    //     fontSize: `${BASE_FONT_SIZE * 1.17}rem`,
    //   },
    //   h4: {
    //     fontSize: `${BASE_FONT_SIZE * 1}rem`,
    //   },
    //   h5: {
    //     fontSize: `${BASE_FONT_SIZE * 0.83}rem`,
    //   },
    //   h6: {
    //     fontSize: `${BASE_FONT_SIZE * 0.67}rem`,
    //   },
    // },
  }),
  {
    factor: 2,
    breakpoints: ['xs', 'sm', 'md', 'lg', 'xl'],
  }
);

export default theme;
